import { Location } from 'history';
import { Filter } from 'mk/bazaar/product/filter/filterUtils';
import { ScrollPosition } from 'mk2/apps/bazaar/reducers/navigation';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

export interface BazaarNavigationLoadApiAction extends Action {
    // ID of currently displayed product
    readonly currentId: number;
}

export const BAZAAR_NAVIGATION_LOAD_API_REQUEST = 'BAZAAR_NAVIGATION_LOAD_API_REQUEST';

export interface BazaarNavigationLoadApiRequestAction extends BazaarNavigationLoadApiAction, APIRequestAction {
    readonly type: typeof BAZAAR_NAVIGATION_LOAD_API_REQUEST;
}

export interface BazaarNavigationLoadApiNormalizedResponse extends NormalizedResponse {
    readonly result: {};
}

export const BAZAAR_NAVIGATION_LOAD_API_SUCCESS = 'BAZAAR_NAVIGATION_LOAD_API_SUCCESS';

export interface BazaarNavigationLoadApiSuccessAction
    extends BazaarNavigationLoadApiAction,
        APISuccessAction<BazaarNavigationLoadApiNormalizedResponse> {
    readonly type: typeof BAZAAR_NAVIGATION_LOAD_API_SUCCESS;
}

export const BAZAAR_NAVIGATION_LOAD_API_FAILURE = 'BAZAAR_NAVIGATION_LOAD_API_FAILURE';

export interface BazaarNavigationLoadApiFailureAction extends BazaarNavigationLoadApiAction, APIFailureAction {
    readonly type: typeof BAZAAR_NAVIGATION_LOAD_API_FAILURE;
}

export const bazaarNavigationLoadApi = {
    request: (currentId: number): BazaarNavigationLoadApiRequestAction => ({
        type: BAZAAR_NAVIGATION_LOAD_API_REQUEST,
        currentId,
    }),
    success: (
        currentId: number,
        response: BazaarNavigationLoadApiNormalizedResponse,
    ): BazaarNavigationLoadApiSuccessAction => ({
        type: BAZAAR_NAVIGATION_LOAD_API_SUCCESS,
        currentId,
        response,
    }),
    failure: (currentId: number, error: any): BazaarNavigationLoadApiFailureAction => ({
        type: BAZAAR_NAVIGATION_LOAD_API_FAILURE,
        currentId,
        error,
    }),
};

export const BAZAAR_NAVIGATION_LOAD = 'BAZAAR_NAVIGATION_LOAD';

export interface BazaarNavigationLoadAction extends BazaarNavigationLoadApiAction {
    readonly type: typeof BAZAAR_NAVIGATION_LOAD;
}

export const bazaarNavigationLoad = (currentId: number): BazaarNavigationLoadAction => ({
    type: BAZAAR_NAVIGATION_LOAD,
    currentId,
});

export const BAZAAR_NAVIGATION_STORE_BACK = 'BAZAAR_NAVIGATION_STORE_BACK';

export interface BazaarNavigationStoreBackAction extends Action {
    readonly type: typeof BAZAAR_NAVIGATION_STORE_BACK;
    readonly back: Location;
    readonly scroll: ScrollPosition;
}

export const bazaarNavigationStoreBack = (back: Location, scroll: ScrollPosition): BazaarNavigationStoreBackAction => ({
    type: BAZAAR_NAVIGATION_STORE_BACK,
    back,
    scroll,
});

export const BAZAAR_NAVIGATION_ACTIVATE = 'BAZAAR_NAVIGATION_ACTIVATE';

export interface BazaarNavigationActivateAction extends Action {
    readonly type: typeof BAZAAR_NAVIGATION_ACTIVATE;
    readonly hash: string;
}

export const bazaarNavigationActivate = (hash: string): BazaarNavigationActivateAction => ({
    type: BAZAAR_NAVIGATION_ACTIVATE,
    hash,
});
